// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".battery-icon_f815 {\n  margin-top: auto;\n  margin-bottom: auto;\n}\n.battery-icon_f815 .label_96d8 {\n  margin-right: 0.75rem;\n}", "",{"version":3,"sources":["/home/runner/work/telemetry/telemetry/ts/packages/frontend/src/component/common/BatteryIcon.scss","BatteryIcon.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,mBAAA;ACCJ;ADCI;EACI,qBAAA;ACCR","file":"BatteryIcon.scss","sourcesContent":[".battery-icon {\n    margin-top: auto;\n    margin-bottom: auto;\n\n    .label {\n        margin-right: 0.75rem;\n    }\n}\n",".battery-icon {\n  margin-top: auto;\n  margin-bottom: auto;\n}\n.battery-icon .label {\n  margin-right: 0.75rem;\n}"]}]);
// Exports
exports.locals = {
	"battery-icon": "battery-icon_f815",
	"label": "label_96d8"
};
module.exports = exports;
